import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import i18n from '../localization/i18next'

type LanguageState = {
  language: string
  changeLanguage: (lang: string) => Promise<void>
}

export const useLanguageStore = create<LanguageState>()(
  persist(
    (set) => ({
      language: 'en', // Default language
      changeLanguage: async (lang: string) => {
        await i18n.changeLanguage(lang)
        set({ language: lang })
      },
    }),
    {
      name: 'language-storage', // unique name for localStorage key
    }
  )
)
